import { render, staticRenderFns } from "./retention.vue?vue&type=template&id=1a3cd0ae&"
import script from "./retention.vue?vue&type=script&lang=js&"
export * from "./retention.vue?vue&type=script&lang=js&"
import style1 from "./retention.vue?vue&type=style&index=1&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports